@let tool = this.tool();
@let toolName = tool.name;
@let start = startJob();
@if (isInitialLoading()) {
  <app-job-timeline-skeleton></app-job-timeline-skeleton>
} @else if (disabled()) {
  <app-tool-node [name]="toolName"></app-tool-node>
} @else {
  @if (job(); as toolJob) {
    <app-parameter-node
      [data]="toolJob.funcInput"
      [interactive]="true"
      [parameters]="tool.inputs"
      (activated)="openDetails(toolJob, 'parameters')"></app-parameter-node>
  } @else if (start; as startJob) {
    <app-input-parameter-node
      [tool]="tool"
      [outputsToMap]="outputsToMap()"
      [startJob]="startJob"
      (submittingChange)="jobStarting.emit($event)"></app-input-parameter-node>
  } @else {
    <app-parameter-node [data]="{ Status: 'Waiting for this tool to start.' }"></app-parameter-node>
  }

  <div class="job-connector" aria-hidden="true"></div>
  <app-tool-node
    [job]="job()"
    [name]="toolName"
    [rerunStep]="rerunStep()"
    [waitingForTool]="!job() && !start"
    (logsRequested)="openLogs($event)"></app-tool-node>

  @if (job(); as toolJob) {
    <div class="job-connector" aria-hidden="true"></div>
    <app-result-node
      [job]="toolJob"
      [parameters]="tool.outputs"
      (activated)="openDetails(toolJob, 'results')"></app-result-node>
  }
}
